<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 nopads">
    <transition name="fade">
      <div v-if="stations.length > 0" class="list-content result-table">
        <vue3-datatable
          :rows="stations"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="50vh"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="rowClicked"
        >
          <template #created_at="row">
            {{ getDateString(row.value.created_at) }}
          </template>
        </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>

import {timeUtils} from "@/components/mixins/TimeUtils";
import {streetLightHelper} from "@/components/mixins/StreetLightMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'PowerStationList',
    components: {Vue3Datatable},
    mixins: [timeUtils, streetLightHelper],
    props: {
        powerStations: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'id',
            sortDesc: false,
            stations: [],
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'location_name', title: this.$t('common.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('street_lights.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'created_at', title: this.$t('road_sign.created_at'), sort: true, headerClass: 'routa-table-header'},
                {field: 'street', title: this.$t('power_stations.street'), sort: true, headerClass: 'routa-table-header'},
                {field: 'city', title: this.$t('power_stations.city'), sort: true, headerClass: 'routa-table-header'},
                {field: 'plate_value', title: this.$t('power_stations.plate_value'), sort: true, headerClass: 'routa-table-header'},
                {field: 'next_inspection_year', title: this.$t('power_stations.next_inspection_year'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract.name', title: this.$t('orders.contract'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        powerStations() {
            this.stations = []
            this.$nextTick(() => {
                let temp = []
                this.powerStations.forEach(item => {
                    let newItem = JSON.parse(JSON.stringify(item));
                    newItem.status = item.status ? this.getStatusString(item.status) : ''
                    temp.push(newItem)
                })
                this.$nextTick(() => {
                    this.stations = temp
                })
            })
        }
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        },
        getFormattedValue: function (value) {
            if (!value || value < 1) {
                return ""
            }
            return value
        }
    }
}
</script>
